import React, { useEffect, useState } from "react";
import Select from 'react-select';

import './DropdownReactSelect.css'

export default function DropdownReactSelect(props) {


  const [name, setName] = useState('');
  const [placeholder, setPlaceholder] = useState('Select...');

  const [defaultValue, setDefaultValue] = useState([]);
  const [value, setValue] = useState([]);
  const [options, setOptions] = useState([]);

  const [isMulti, setIsMulti] = useState(true);
  const [isOptionDisabled, setIsOptionDisabled] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isClearable, setIsClearable] = useState(true);
  const [isSearchable, setIsSearchable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRtl, setIsRtl] = useState(false);
  const [closeMenuOnSelect, setCloseMenuOnSelect] = useState(false);

  const colourStyles = {
    control: styles => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      // const color = chroma(data.color);
      return {
        ...styles,
        backgroundColor: isSelected ? '#F3F6F9' : isFocused ? '#F3F6F9' : '#fff',
        color: '#000',
        zIndex: 9999
        // cursor: isDisabled ? 'not-allowed' : 'default',
      };
    },
  };

  useEffect(() => {
    if (props?.name !== undefined)
      setName(props?.name);
  }, [props?.name]);

  useEffect(() => {
    if (props?.placeholder !== undefined)
      setPlaceholder(props?.placeholder);
  }, [props?.placeholder]);

  useEffect(() => {
    if (props?.defaultValue !== undefined)
      setDefaultValue(props?.defaultValue);
  }, [props?.defaultValue]);

  useEffect(() => {
    if (props?.value !== undefined)
      setValue(props?.value);
  }, [props?.value]);

  useEffect(() => {
    if (props?.options !== undefined)
      setOptions(props?.options);
  }, [props?.options]);

  useEffect(() => {
    if (props?.isMulti !== undefined && props?.isMulti !== null)
      setIsMulti(props?.isMulti);
  }, [props?.isMulti]);

  useEffect(() => {
    if (props?.isDisabled !== undefined && props?.isDisabled !== null)
      setIsDisabled(props?.isDisabled);
  }, [props?.isDisabled]);

  useEffect(() => {
    if (props?.isOptionDisabled !== undefined && props?.isOptionDisabled !== null)
      setIsOptionDisabled(props?.isOptionDisabled);
  }, [props?.isOptionDisabled])

  useEffect(() => {
    if (props?.isClearable !== undefined && props?.isClearable !== null)
      setIsClearable(props?.isClearable);
  }, [props?.isClearable]);

  useEffect(() => {
    if (props?.isSearchable !== undefined && props?.isSearchable !== null)
      setIsSearchable(props?.isSearchable);
  }, [props?.isSearchable]);

  useEffect(() => {
    if (props?.isLoading !== undefined && props?.isLoading !== null)
      setIsLoading(props?.isLoading);
  }, [props?.isLoading]);

  useEffect(() => {
    if (props?.isRtl !== undefined && props?.isRtl !== null)
      setIsRtl(props?.isRtl);
  }, [props?.isRtl]);

  useEffect(() => {
    if (props?.closeMenuOnSelect !== undefined && props?.closeMenuOnSelect !== null)
      setCloseMenuOnSelect(props?.closeMenuOnSelect);
  }, [props?.closeMenuOnSelect]);

  const onChangeSelectDropdown = (e) => {
    // console.log(e);
    props.onChange(e);
  }
  const [isOpen, setIsOpen] = useState(false);

  return (
    // <div
    //   // onClose={() => { setIsOpen(false) }}
    // >
    //   <button
    //     // iconAfter={<ChevronDown />}
    //     onClick={() => { setIsOpen(true) }}
    //   >
    //     {/* {value ? `State: ${value.label}` : 'Select a State'} */}
    //     Select
    //   </button>
    //   {
    //     isOpen &&
    <Select
      className="basic-multi-select"
      classNamePrefix="select"

      placeholder={placeholder}
      name={name}

      isMulti={isMulti}
      isDisabled={isDisabled}
      isClearable={isClearable}
      isSearchable={isSearchable}
      isLoading={isLoading}
      isRtl={isRtl}
      closeMenuOnSelect={closeMenuOnSelect}
      isOptionDisabled={isOptionDisabled == true && value != null ? () => value.length >= 1 : false}
      defaultValue={defaultValue}
      value={value}
      options={options}
      styles={colourStyles}

      onChange={(e) => onChangeSelectDropdown(e)}
    />
    //   }

    // </div>

  )
}
